export default __webpack_public_path__ + "static/media/card-brand.793eb728.svg";